import React from "react";
import TabelaProdap from "features/shared/components/TabelaProdap";
import { tableStyles } from "./tableStyle";
import { withStyles } from "@material-ui/core";
import { formatKgOrZero } from "../utils";
import { Trans, useTranslations } from "adapters/i18n";
import { BannerAlert } from "features/shared/components";

function PlanningFormulaReportTable({
  planningFormulaReport,
  periodTitles,
  classes,
}) {
  const { t } = useTranslations();

  const planningFormulaReportTableViewColumns = () => {
    const periodColumns = periodTitles.map((month, monthIndex) => ({
      id: month,
      titulo: month,
      ordenavel: false,
      pegaValor: (report) => (
        <span>{formatKgOrZero(report.months[monthIndex] || 0)}</span>
      ),
    }));

    return [
      {
        id: "formulacao",
        titulo: t("supplementation:formulation"),
        ordenavel: false,
        pegaValor: (report) => <span>{report.formula.name}</span>,
      },
      ...periodColumns,
      {
        id: "total",
        titulo: t("common:total"),
        ordenavel: false,
        pegaValor: (report) => (
          <span className={classes.cellItemBold}>
            {formatKgOrZero(report.total || 0)}
          </span>
        ),
      },
    ];
  };

  return (
    <div className={classes.container}>
      <h1 className={classes.tableTitle}>
        {t("planning:report.formula-title")}
      </h1>
      <div
        className={classes.tableContent}
        data-testid="Plannings-Formula-Report-Table"
      >
        <TabelaProdap
          className={classes.tableContainer}
          idCabecalhoTabela={"planningFormulaReportTableHead"}
          colunas={planningFormulaReportTableViewColumns()}
          ativarPaginacao={false}
          linhas={planningFormulaReport}
          tabelaEsquerda={true}
          noPaper
        />
      </div>
      <BannerAlert className={classes.disclaimer} type="plain">
        <Trans i18nKey="planning:report.disclimer-formula" />
      </BannerAlert>
    </div>
  );
}

const style = (theme) => ({
  ...tableStyles(theme),
  disclaimer: {
    marginTop: "12px",
  },
});

export default withStyles(style)(PlanningFormulaReportTable);
